export type DashboardStatsForCollection = {
  sabilForecast?: number;
  paymentsReceived?: number;
};

/** Collection % shown in sabil dashboard header and progress card. */
export function computeSabilCollectionPercentage(stats: DashboardStatsForCollection): number {
  if (!stats.sabilForecast || stats.sabilForecast === 0) return 0;
  return Math.round((stats.paymentsReceived! / stats.sabilForecast) * 100);
}
